import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { getLinkOptionsData } from '@Pages/RetroSynthesis/LinkOption/selectors';
import LinkOption from '@Pages/RetroSynthesis/LinkOption/LinkOption';
import { linkOptionCheckedAction, linkOptionsClearAction, linkOptionsCloseAction } from '@Pages/RetroSynthesis/LinkOption/actions';
import { LinkOptionType } from '@Pages/RetroSynthesis/LinkOption/constants';
import { onStepSelected } from '@Pages/RetroSynthesis/ProjectRoute/analytics';
import { requestParams, routeType as routeTypeSelector } from '@Pages/RetroSynthesis/ProjectRoute/selectors';
import { onAddStepClick, onCopyReaction, onStepDeleteClick } from '@Pages/RetroSynthesis/LinkOption/analytics';
import { getProjectsInfoMap } from '@Pages/RetroSynthesis/RsBreadcrumbs/selector';

/* eslint-disable no-shadow */
/* eslint-disable react-hooks/exhaustive-deps */
function LinkOptionContainer({
  projectId,
  routeId,
  step,
  targetRect,
  linkOptionsCloseAction,
  linkOptionCheckedAction,
  linkOptionsClearAction,
  projectsInfoMap,
  routeType,
}) {
  useEffect(() => linkOptionsClearAction, []);
  const projectInfo = projectsInfoMap && projectsInfoMap[projectId];
  const trackAction = ({ optionType, step }) => {
    switch (optionType) {
      case LinkOptionType.SHOW_CONDITIONS:
        onStepSelected({ projectId, routeId, stepNumber: step.step, projectInfo, routeType });
        break;
      case LinkOptionType.ADD_REACTION_STEP:
        onAddStepClick({ projectId, routeId, stepNumber: step.step, projectInfo, routeType });
        break;
      case LinkOptionType.DELETE_PRIOR_STEPS:
        onStepDeleteClick({ projectId, routeId, stepNumber: step.step, projectInfo, routeType });
        break;
      case LinkOptionType.COPY_REACTION:
        onCopyReaction({ projectId, routeId, stepNumber: step.step, projectInfo, routeType });
        break;
      default:
        break;
    }
  };

  return (
    <LinkOption
      step={step}
      targetRect={targetRect}
      onClosed={linkOptionsCloseAction}
      onOptionChecked={(optionType) => {
        linkOptionCheckedAction({ optionType, step, projectId, routeId, projectInfo, routeType });
        trackAction({ optionType, step });
      }}
    />
  );
}

const mapStateToProps = (state) => {
  const { targetRect, step } = getLinkOptionsData(state);
  const { projectId, routeId } = requestParams(state);
  return {
    targetRect,
    step,
    projectId,
    routeId,
    projectsInfoMap: getProjectsInfoMap(state),
    routeType: routeTypeSelector(state),
  };
};

const mapDispatchToProps = {
  linkOptionsCloseAction,
  linkOptionCheckedAction,
  linkOptionsClearAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(LinkOptionContainer);
